import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { sendForgotPassword } from '../store';

import { DashboardHelpers } from '@/utils/DashboardHelpers';

import { useAppDispatch } from '@/hooks/redux-helpers';

export function useUserActions() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const navigateToUser = useCallback(
    (userId: number, shouldOpenNewTab?: boolean) => {
      if (shouldOpenNewTab) {
        window.open(DashboardHelpers.generateProfilePath(userId), '_blank');
      } else {
        navigate(DashboardHelpers.generateProfilePath(userId));
      }
    },
    [navigate],
  );

  const sendForgotPasswordEmail = (userId: number, email: string) => {
    if (!email) return;
    dispatch(sendForgotPassword(userId, email));
  };

  return {
    navigateToUser,
    sendForgotPasswordEmail,
  };
}
